import { render, staticRenderFns } from "./AppealHistoryModal.vue?vue&type=template&id=25ad7aa8&scoped=true"
import script from "./AppealHistoryModal.vue?vue&type=script&lang=js"
export * from "./AppealHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad7aa8",
  null
  
)

export default component.exports